import { Component, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ApiService } from '../../../core/services/api.service';
import { ServiceLocalStorage } from '../../../core/services/local-storage.service';
import { NotificationService } from '../../../core/services/notification.service';
import { ServiceExportExcel } from '../../../core/services/export.service';
import { ApiConstants } from '../../../core/constants/api-path.constants';
import { of } from "rxjs";
import { MatAccordion } from '@angular/material/expansion';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

export interface PeriodicElement {
  employeeId: string,
  employeeName: string,
  gender: string,
  address: string,
  contact: string,
  distance: string,
  time: string,
  showstatus: string,
  adtime: string,
}


@Component({
  selector: 'app-delete-vendor-allocation',
  templateUrl: './delete-vendor-allocation.component.html',
  styleUrls: ['./delete-vendor-allocation.component.scss']
})
export class DeleteVendorAllocationComponent implements OnInit {

  _mFormGroup: FormGroup;
  private mSite = new FormControl('', Validators.required);
  private mDate = new FormControl('', Validators.required);
  private mLogType = new FormControl('', Validators.required);
  private mShiftTime: any = new FormControl('', Validators.required);

  shiftTimeDDSettings = {
    itemsShowLimit: 1,
    idField: "shiftTimeId",
    textField: "shiftTime",
    allowSearchFilter: true,
    searchPlaceholderText: "Search"
  };

  ELEMENT_DATA: PeriodicElement[] = [];
  displayedColumns: string[] =
    ['employeeId',
      'employeeName',
      'gender',
      'address',
      'contact',
      'distance',
      'time',
      'showstatus',
      'adtime']
  dataSource = new MatTableDataSource<PeriodicElement>(this.ELEMENT_DATA);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();

  _mSitesData: any[] = [];
  _mData: any[] = [];
  date = new Date();
  tripSheetflag: boolean = false;
  checkedFlag: boolean = false;
  tripsheet: any;
  tripViewList: any[] = [];
  checkedTrips: any = [];
  displayedRows$: any[] = [];
  _mShiftTimeList: any[] = [];
  userId: any = '';
  logType = [{ "key": "IN" }, { "key": "OUT" }];
  @ViewChild(MatAccordion) accordion: MatAccordion;
  minDate = new Date();
  allExpandState: any;
  activeTabId = 1;
  _mCurrentUserData: any;

  constructor(
    private fb: FormBuilder,
    private readonly apiService: ApiService,
    private notifyService: NotificationService,
    private ngxLoader: NgxUiLoaderService,
    private readonly localStorage: ServiceLocalStorage,
    private serviceExportExcel: ServiceExportExcel,
    public readonly serviceLocalStorage: ServiceLocalStorage,
  ) {
    this._mFormGroup = this.fb.group({
      'site': this.mSite,
      'date': this.mDate,
      'logType': this.mLogType,
      'shiftTime': this.mShiftTime
    });
  }

  ngOnInit(): void {
    this.userId = this.localStorage.getUserId();
    this.getActiveSites();
    this.mLogType.setValue(this.logType[0].key);
    this._mFormGroup.get('date').setValue(new Date());
    this._mCurrentUserData = this.serviceLocalStorage.getUserObject();
  }

  getActiveSites() {
    this.apiService.doGetRequestWithResponse(ApiConstants.getActiveSitesbyUser + '?userId=' + this.userId,
      (success) => {
        if (success.status == 200) {
          this._mSitesData = success.body || [];
          if (this._mSitesData.length > 0) {
            const userMappedSiteId = this._mCurrentUserData?.userInfoDetails?.site?.siteId;
            const matchedSite = this._mSitesData.find(
              s => s.siteId === userMappedSiteId
            );

            if (matchedSite) {
              this.mSite.setValue(userMappedSiteId);
            } else {
              this.mSite.setValue(this._mSitesData[0].siteId);
            }

            this.onLogTypeChange();
          }
        } else {
          this._mSitesData = [];
          this.notifyService.showInfo("No sites found", null);
        }
      },
      (error) => { }
    );
  }

  onLogTypeChange() {
    this.ngxLoader.start();
    let url = ApiConstants.getShiftTimesBySiteIdShiftTypeAndLogType
      + this.mSite.value + "&logtype=" + this.mLogType.value + "&shifttype=" + 'General';
    this.apiService.doGetRequestWithResponse(url, (success) => {
      this.ngxLoader.stop();
      if (success.status == 200) {
        this._mShiftTimeList = success.body;
        if (this._mShiftTimeList.length > 0) {
          this.mShiftTime.setValue([this._mShiftTimeList[0]]);
        }
      } else {
        this.notifyService.showInfo("No shift times found", null);
      }
    }, (error) => {
      this.notifyService.showError(error, null);
      this.ngxLoader.stop();
    })
  }

  dateChanged(data) {
    this.mDate.setValue(data.value);
  }

  formatDate(d): any {
    let m = d.getMonth() + 1;
    let dt = (d.getDate() < 10) ? '0' + d.getDate() : d.getDate();
    let mm = (m < 10) ? '0' + m : m;
    return dt + '/' + mm + '/' + d.getFullYear();
  }

  onShow() {
    if (!this.mSite.value) {
      this.notifyService.showWarning("Please select the site", null);
      return;
    }
    if (!this.mDate) {
      this.notifyService.showWarning("Please select the Date", null);
      return;
    }
    if (!this.mLogType.value) {
      this.notifyService.showWarning("Please select the Log type", null);
      return;
    }
    if (!this.mShiftTime.value) {
      this.notifyService.showWarning("Please select the Shift time", null);
      return;
    }
    const shiftList = this.mShiftTime.value.map(shift => shift.shiftTimeId);
    this.tripViewList = [];
    this.displayedRows$ = [];
    const rows$ = of(this.tripViewList);
    this.displayedRows$ = this.tripViewList;
    this.ngxLoader.start();
    const endpoint = `${ApiConstants.deleteVendorAllocation}${this.mSite.value}&date=${this.formatDate(this.mDate.value)}`;
    this.apiService.doPostRequestWithResponse(endpoint, shiftList,
      success => {
        this.ngxLoader.stop();
        if (success.status === 200) {
          this.processTripsData(success.body);
        } else {
          this.resetTripsData();
          this.notifyService.showWarning("No Trips Found", null);
        }
      },
      error => {
        this.ngxLoader.stop();
        this.resetTripsData();
        this.notifyService.showWarning("No Trips Found", null);
      }
    );
  }

  processTripsData(data) {
    this._mData = data;
    this.ELEMENT_DATA = data;
    this.dataSource = new MatTableDataSource<PeriodicElement>(data);
    this.tripsheet = data;
    this.checkAll(false);
    this.tripSheetflag = true;
    this.tripsheet.forEach(element => {
      const tripemp = element.tripDetails.tripUsers.map(tripuser => ({
        employeeId: tripuser.tripUser.userInfoDetails.employeeId || "",
        employeeName: tripuser.tripUser.userInfoDetails.displayName || "",
        gender: tripuser.tripUser.userInfoDetails.gender || "NA",
        userid: tripuser.tripUser.id,
        bookingid: tripuser.booking?.bookingId || null,
        address: tripuser.landmark.landmark || "NA",
        distance: tripuser.empTripDistance || "0",
        time: tripuser.pickupDropTime ? tripuser.pickupDropTime.slice(0, -3) : "00:00",
        userColor: tripuser.tripUser.userInfoDetails.userCategory[0]?.categories.colorCode || "#006aa8",
        medical: false,
        showstatus: tripuser.showStatus || "NO SHOW",
        contact: tripuser.tripUser.userInfoDetails.contactNumber || "NA",
        adtime: element.tripDetails.shift.logType === "IN" ? tripuser.arrivalDateTime : tripuser.boardedDateTime
      }));

      const isInTrip = element.tripDetails.shift.logType === "IN";
      const pickupDropPoint = isInTrip
        ? element.tripDetails.tripUsers[0]?.landmark.area?.area || "NA"
        : element.tripDetails.tripUsers[tripemp.length - 1]?.landmark.area?.area || "NA";
      this.tripViewList.push({
        tripid: element.tripDetails.tripId || "",
        tripCode: element.tripDetails.tripCode || "NA",
        vehicleNo: element.vehicle?.registrationNo || "NA",
        Vendor: element.vendorMaster?.name || "NA",
        Driver: element.driver?.name || "NA",
        Number: element.driver?.contactNumber || "NA",
        pickupDropPoint,
        vehicleType: element.vehicleType.vehicleType,
        escort: element.tripDetails.escortStatus ? "YES" : "NO",
        distance: element.tripDetails.tripDistance || "0",
        seatCapacity: element.vehicleType.seatCapacity,
        seatsOccupied: tripemp.length + (element.tripDetails.escortStatus ? 1 : 0),
        tripemp,
        escortname: element.escort?.name || "",
        alloacateVehicle: element.vehicle?.vehicleType.vehicleType || "NA",
        triptraveltime: element.tripDetails.tripTravelTime,
        shift: `${element.tripDetails.shift.shiftTime} ${element.tripDetails.shift.logType}`,
        date: element.tripDetails.tripDate.split(" ")[0],
        seatsOccupiedPercent: ((tripemp.length + (element.tripDetails.escortStatus ? 1 : 0)) / element.vehicleType.seatCapacity * 100).toFixed(2),
        tatd: isInTrip ? element.startDateTime : element.stopDateTime
      });
    });
  }

  resetTripsData() {
    this._mData = [];
    this.ELEMENT_DATA = [];
    this.dataSource = new MatTableDataSource<PeriodicElement>([]);
    this.tripSheetflag = false;
  }

  checkTrip(event, tripid) {
    if (event.checked) {
      this.checkedTrips.push(tripid);
    } else {
      this.checkedTrips = this.checkedTrips.filter(id => id !== tripid);
    }
  }


  checkAll(event) {
    this.checkedFlag = event.checked;
    this.checkedTrips = event.checked ? this.tripViewList.map(trip => trip.tripid) : [];
  }

  onExportToExcel(): void {
    if (!this.tripViewList.length) {
      this.notifyService.showInfo("No data found", null);
      return;
    }

    this.notifyService.showInfo("Please wait", null);
    const exceldata = [];
    const siteName = this._mSitesData[0]?.siteName || "";
    this.tripViewList.forEach((trip, index) => {
      exceldata.push({
        tripCode: trip.tripCode,
        vehicleNo: trip.vehicleNo,
        vendor: trip.Vendor,
        driver: trip.Driver,
        contactNo: trip.Number,
        location: trip.pickupDropPoint,
        vehicleType: trip.vehicleType,
        escortRequired: trip.escort,
        escortName: trip.escortname,
        distance: trip.distance,
        seatCapacity: trip.seatCapacity,
        seatOccupied: trip.seatsOccupied,
        allocateVehicle: trip.alloacateVehicle,
        tripTravelTime: trip.triptraveltime,
        site: siteName,
        shift: trip.shift,
        date: trip.date,
        seatOccupiedPercent: trip.seatsOccupiedPercent
      });

      exceldata.push({
        tripCode: "EmployeeId",
        vehicleNo: "EmployeeName",
        vendor: "Gender",
        driver: "Distance",
        contactNo: "Time",
        location: "Medical",
        vehicleType: "TravelStatus",
        escortRequired: "Contact",
        escortName: "Address"
      });

      trip.tripemp.forEach(emp => {
        exceldata.push({
          tripCode: emp.employeeId,
          vehicleNo: emp.employeeName,
          vendor: emp.gender,
          driver: emp.distance,
          contactNo: emp.time,
          location: emp.medical,
          vehicleType: emp.showstatus,
          escortRequired: emp.contact,
          escortName: emp.address
        });
      });

      if (index < this.tripViewList.length - 1) {
        exceldata.push({}, this.createHeaderRow());
      }
    });

    this.serviceExportExcel.exportAsExcelFile(exceldata, "VendorAssignedTrips");
  }

  createHeaderRow() {
    return {
      tripCode: "tripCode",
      vehicleNo: "vehicleNo",
      vendor: "vendor",
      driver: "driver",
      contactNo: "contactNo",
      location: "location",
      vehicleType: "vehicleType",
      escortRequired: "escortRequired",
      escortName: "escortName",
      distance: "distance",
      seatCapacity: "seatCapacity",
      seatOccupied: "seatOccupied",
      allocateVehicle: "allocateVehicle",
      tripTravelTime: "tripTravelTime",
      site: "site",
      shift: "shift",
      date: "date",
      seatOccupiedPercent: "seatOccupiedPercent"
    };
  }

  onDelete() {
    if (this.checkedTrips.length < 1) {
      this.notifyService.showWarning("Select atleast one trip to delete", null);
    } else {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: 'btn btn-success mt-5',
          cancelButton: 'btn btn-danger ms-2 mt-5'
        },
        buttonsStyling: false
      });
      swalWithBootstrapButtons.fire({
        title: 'WARNING : Are you sure want to delete the selected Trips?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it',
        cancelButtonText: 'No, keep it',
        confirmButtonColor: '#34c38f',
        cancelButtonColor: '#f46a6a',
      }).then((result) => {
        if (result.value) {
          this.ngxLoader.start();
          this.apiService.doPostRequestWithResponse(ApiConstants.deleteAllocatedtrip, this.checkedTrips, (success) => {
            this.ngxLoader.stop();
            if (success.status == 202) {
              this.checkedTrips = [];
              this.notifyService.showSuccess(success.body.message, null)
              this.onShow();
            }
          }, (error) => {
            this.ngxLoader.stop();
          })
        } else if (result.dismiss) {
          swalWithBootstrapButtons.fire(
            'Cancelled',
            'Your selected Trips are safe :)',
            'error'
          )
        }
      })
    }
  }

}